import useBoolean from '../boolean';

export default(initialValue: boolean = false) => {
    const [value, on, off] = useBoolean(initialValue);

    return [value, value ? off : on];
};
